/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ message: NonNullable<unknown> }} Automatic_Save_Event_Groups_Restore_FailedInputs */



/**
* | output |
* | --- |
* | "Event groups failed to restore. {message}" |
*
* @param {Automatic_Save_Event_Groups_Restore_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const automatic_save_event_groups_restore_failed = /** @type {((inputs: Automatic_Save_Event_Groups_Restore_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automatic_Save_Event_Groups_Restore_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Échec de la restauration des groupes d’événements. ${i?.message}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Ereignisgruppen konnten nicht wiederhergestellt werden. ${i?.message}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Impossibile ripristinare i gruppi di eventi. ${i?.message}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Не удалось восстановить группы событий. ${i?.message}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Los grupos de eventos no se pudieron restaurar. ${i?.message}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`事件组恢复失败。${i?.message}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`イベント グループの復元に失敗しました。${i?.message}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`इवेंट समूह पुनर्स्थापित करने में विफल रहे। ${i?.message}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Os grupos de eventos não puderam ser restaurados. ${i?.message}`)
	return /** @type {LocalizedString} */ (`Event groups failed to restore. ${i?.message}`)
});